import script from "./SidebarNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarNav.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarNav.vue?vue&type=style&index=0&id=74583d02&scoped=true&lang=scss"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74583d02"]])

export default __exports__